export const ALLOWED_TO_CREATE_ORGANIZATION = [
    'group_owner',
    'group_administrator',
] as const;
